<template>
    <div>
        <div style="position: relative" class="four-three" v-if="row.photo || row.video">
            <div class="content">
                <div class="protection anchor-parent"></div>
                <!--
                <button type="button" class="btn default btn-xs blue"
                        style="position: absolute; z-index: 2"
                        :style="galleryButtonStyle"
                        title="Visualizar galeria"
                        v-tooltip
                        v-property-gallery
                        :property="row">
                    <a href="javascript:;" style="color: #FFF"><i class="fa fa-camera"></i></a>
                </button>
                -->
                <div style="position: absolute; z-index: 2"
                    :style="galleryButtonStyle">
                    <media-button
                        v-ref:media
                        :label="photosLabel"
                        :property-id="row.id" 
                        :disabled="false"></media-button>
                </div>

                <div v-if="row.photo">
                    <div v-if="row.photo.thumbnails.wmedium"
                         class="anchor-parent background-cover"
                         @click.prevent="openMedia"
                         :style="{padding: '10px 0', backgroundImage: `url(${row.photo.thumbnails.wmedium})`}">
                    </div>
                </div>

                <div v-if="!row.photo && row.video">
                    <div v-if="row.video.thumbnail"
                         class="anchor-parent background-cover"
                         @click.prevent="openMedia"
                         :style="{padding: '10px 0', backgroundImage: `url(${row.video.thumbnail})`}">
                    </div>

                    <div v-if="!row.video.thumbnail"
                         class="anchor-parent background-cover"
                         @click.prevent="openMedia"
                         :style="{padding: '10px 0', 'background-image': $asset('/assets/images/imagem-nao-disponivel-media.png', 'url(%s)')}">
                    </div>
                </div>
            </div>
        </div>


        <div style="position: relative" class="four-three" v-if="!row.photo && !row.video">
            <div class="content">

                <div style="position: absolute; z-index: 2"
                    :style="galleryButtonStyle">
                    <media-button
                        :label="photosLabel"
                        :property-id="row.id" 
                        :disabled="true"></media-button>
                </div>
                <!--
                <button type="button" class="btn default btn-xs"
                        style="position: absolute; top: 15px; left: 15px; z-index: 2"
                        title="Não há imagens ou vídeos"
                        v-tooltip>
                    <a href="javascript:;" style="color: #FFF"><i class="fa fa-camera"></i></a>
                </button>
                -->


                <div class="anchor-parent background-cover"
                     :style="{padding: '10px 0', 'background-image': $asset('/assets/images/imagem-nao-disponivel-media.png', 'url(%s)')}">
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .protection {
        position: absolute;
        box-shadow: inset 0px 0px 0px 1px #efefef;
        z-index: 9;
        mix-blend-mode: darken;
        pointer-events: none;
    }
</style>
<script>
    export default {
        components: {
            MediaButton: require('components/property/MediaButton.vue'),
        },
        props: {
            row: {
                type: Object,
                required: true
            },
            padding: {
                type: Number,
                default: 15
            },
            photosCount: {
                type: Number,
                required: false
            },
            minPhotos: {
                required: false,
            }
        },
        methods: {
            openMedia (evt) {
                evt.preventDefault()
                evt.stopPropagation()
            },
        },
        computed: {
            photosLabel () {
                if (this.minPhotos === false) {
                    return ''
                }

                return `${this.photosCount || 0} / ${this.minPhotos}`
            },
            galleryButtonStyle () {
                return {
                    top: `${this.padding}px`,
                    left: `${this.padding}px`
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Media.vue?263fd084